<template>
    <div>
         <!-- main-area -->
         <main class="fix">
                <!-- breadcrumb-area -->
                <section class="breadcrumb__area breadcrumb__bg">
                    <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100 kantor-bg"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="breadcrumb__content">
                                    <h2 class="title">Profil Pegawai</h2>
                                    <nav aria-label="breadcrumb">
                                        <ol class="breadcrumb">
                                            <li class="breadcrumb-item"><a href="index.html">Profil</a></li>
                                            <li class="breadcrumb-item active" aria-current="page">Profil Pegawai</li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="breadcrumb__shape">
                        <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                    </div>
                </section>


                <section class="team__area-two">
                <div class="container">
                    <div class="row justify-content-center gutter-24">

                        <div class="col-lg-3 col-md-6 col-sm-8" v-for="(data) in list_data" :key="data.id">
                            <div class="team__item-two shine-animate-item" >
                                <div class="team__thumb-two shine-animate">
                                    <img :src="data.file ? file_path + data.file : 'assets/img/user.png'" alt="Foto Pegawai" />
                                </div>
                                <div class="team__content-two">
                                    <h4 class="title"><a href="javascript:void(0);">{{ data.gelar_depan }} {{ data.nama }}, {{ data.gelar_belakang }}</a></h4>
                                    <span>{{ data.nm_jabatan}}</span>
                                    
                                </div>
                            </div>

                        </div>
                        <div class="pagination-wrap mt-40">
                                        <nav aria-label="Page navigation example">
                                            <ul class="pagination list-wrap">
                                            <li class="page-item" :class="{ disabled: page_first === 1 }">
                                                <a class="page-link" href="#" @click.prevent="btn_prev"><i class="fas fa-angle-double-left"></i></a>
                                            </li>
                                            <li
                                                class="page-item"
                                                v-for="page in page_last"
                                                :key="page"
                                                :class="{ active: page === page_first }"
                                            >
                                                <a class="page-link" href="#" @click.prevent="go_to_page(page)">{{ page }}</a>
                                            </li>
                                            <li class="page-item" :class="{ disabled: page_first === page_last }">
                                                <a class="page-link" href="#" @click.prevent="btn_next"><i class="fas fa-angle-double-right"></i></a>
                                            </li>
                                            </ul>
                                        </nav>
                                        </div>

                    </div>
                </div>
                <div class="about__shape-wrap-four">
                    <img src="assets/img/images/h4_about_shape01.png" alt="">
                    <img src="assets/img/images/h4_about_shape02.png" alt="" data-parallax='{"x" : -80 , "y" : -80 }'>
                </div>
            </section>
                    <!-- about-area-end -->
                <!-- breadcrumb-area-end -->
               
                
            </main>
            <!-- main-area-end -->
    
    
    </div>
    </template>

    <script>


        export default {

            data() {
                return {
                    file_path: this.$store.state.URL_APP_SIMPEG + "uploads/",
                    list_data: [],
                    page_first: 1,
                    page_last: 0,

                    cari_value: "",
                    uraian: "",
                }
            },
            methods: {
                getView: function() {
                    this.cek_load_data = true;
                    fetch(this.$store.state.ADD_URL_PEGAWAI + "view", {
                        method: "POST",
                        headers: {
                        "content-type": "application/json",
                        // authorization: "kikensbatara " + localStorage.token,
                        },
                        body: JSON.stringify({
                        data_ke: this.page_first,
                        cari_value: this.cari_value
                        }),
                    })
                        .then((res) => res.json())
                        .then((res_data) => {
                        this.list_data = res_data.data;
                        this.page_last = res_data.jml_data;
                        console.log(res_data)
                        });
                    },

// ================== PAGINASI ====================
                    go_to_page(page) {
                        if (page >= 1 && page <= this.page_last) {
                            this.page_first = page;
                            this.getView(); // ambil data berdasarkan page terbaru
                        }
                        },

                        btn_prev() {
                        if (this.page_first > 1) {
                            this.page_first--;
                            this.getView();
                        }
                        },

                        btn_next() {
                        if (this.page_first < this.page_last) {
                            this.page_first++;
                            this.getView();
                        }
                        },
            
            
            // ================== PAGINASI ====================
            },
            // =============================================================== METHODS =========================================================================

            mounted() {

            this.getView();


                
            }
            };



    </script>



